import BaseEventTypes from "./BaseEventTypes";
import SentreeBadInstallSubEventTypes from "./Sentree/SentreeBadInstallSubEventTypes";
import SentreeEventTypes from "./Sentree/SentreeEventTypes";
import SentreeSteadyStateSubEventTypes from "./Sentree/SentreeSteadyStateSubEventTypes";
import WaterEventTypes from "./Water/WaterEventTypes";

export type AnyEventTypes = SentreeEventTypes | WaterEventTypes | BaseEventTypes;
export type AnySubEventTypes = SentreeBadInstallSubEventTypes | SentreeSteadyStateSubEventTypes;
export type AnySubEventTypesType = (typeof SentreeBadInstallSubEventTypes) | (typeof SentreeSteadyStateSubEventTypes);

const _subTypeMap: Map<AnyEventTypes, AnySubEventTypesType> = new Map();
_subTypeMap.set(SentreeEventTypes.badInstall, SentreeBadInstallSubEventTypes);
_subTypeMap.set(SentreeEventTypes.steadyState, SentreeSteadyStateSubEventTypes);

export function hasSubType(name: AnyEventTypes): boolean {
    return _subTypeMap.has(name);
}

export function getSubType(name: AnyEventTypes): AnySubEventTypesType | undefined {
    if (name === null) {
        return undefined;
    }
    return _subTypeMap.get(name);
}